const departementData = [
    
]

export default departementData;